import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'lineChart',
  props: ['chart'],
  methods: {
    initLineChart: function initLineChart(data, textColor, legendSelect, selectedMode) {
      var legendSelect1 = {};

      if (data.legendData.includes('进水累计流量') || data.legendData.includes('出水累计流量')) {
        data.legendData.forEach(function (item) {
          if (item.indexOf('累计流量') != -1) {
            legendSelect1[item] = false;
          } else {
            legendSelect1[item] = true;
          }
        });
      }

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function formatter(params) {
            var str = '';

            if (params && params.length > 0) {
              str += params[0].name;
              params.forEach(function (item, index) {
                str += "<br/>".concat(item.marker).concat(item.seriesName, ":").concat(item.data).concat(data.seriesData[item.seriesIndex].hasOwnProperty('unit') ? "(".concat(data.seriesData[item.seriesIndex].unit, ")") : '');
              });
            }

            return str;
          }
        },
        legend: {
          data: data.legendData,
          textStyle: {
            color: textColor || '#fff'
          },
          axisLabel: {
            color: textColor || '#fff' //刻度线标签颜色

          },
          show: legendSelect ? false : true,
          selected: legendSelect || legendSelect1,
          selectedMode: selectedMode ? 'single' : 'multiple'
        },
        grid: {
          left: '7%',
          right: '6%',
          bottom: '8%',
          top: '15%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          axisLabel: {
            color: textColor || '#fff' //刻度线标签颜色

          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: textColor || '#fff'
            }
          },
          data: data.xData
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            color: textColor || '#fff' //刻度线标签颜色

          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: textColor || '#fff'
            }
          }
        }],
        series: data.seriesData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option, true);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};